import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchProductDataWithId } from '../../features/dashboard/DocumentSlice';
import Loading from '../../Loading';
import Spinner from '../../Spinner';
import Header from '../../component/dashboard/Header';
import Input from '../../component/form/Input';
import InputRef from '../../component/form/InputRef';
import Select from '../../component/form/Select';
import Button from '../../component/form/Button';
import style from './document.module.css';
import { setLocale } from 'yup';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { ToastContainer, toast } from 'react-toastify';
import Message from '../form/Message'
import { param } from 'jquery';

function DocumentPrint () {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id} = useParams()
    let {
        printData,
    } = useSelector(state => state.document)

    const token = localStorage.getItem('token')

    const {
        loading,
        success,
        error,
        message,
        store,
    } = useSelector(state => state.document)

    const documentPrintHandler = (event) => {
        event.preventDefault()
        window.print()

    }
    const goToDocumentIndex = () => {
        navigate('/dashboard/documents', { replace: true })
    }

    useEffect(() => {
        const data = {
            'id': id
        }
        dispatch(fetchProductDataWithId(data))
           
        if(success === true && loading === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 800,
              })
        }
        if(loading === true) 
            document.body.style.overflow = "hidden"
        if(loading === false)
            document.body.style.overflow = "auto"  
        return () => {
            printData = null
        }
    },[])

    return (
        <>
        { loading ? (<Loading />) : null}
        {
            (typeof printData === 'undefined') ? null : 
                (Object.keys(printData).length != 0) ? (
                <>   
                    <div className='row g-2 p-5 my-5'>  
                        <Header title='اطلاعات کارخانه' />  
                        <div className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column justify-content-around align-items-center border font'>
                            <input type="hidden" value={printData.mt_sanadno}/>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center fs-5">
                                <div className="fw-bold"> شماره پلاک : </div>
                                <div className='d-flex flex-column justify-content-center align-items-center'>
                                <span className="px-3 border-bottom border-dark">{printData.mt_pelakserial}</span>
                                <span className="px-3">
                                    {printData.mt_pelakno}
                                </span>
                                </div>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center fs-5">
                                <div className="fw-bold"> تاریخ نصب : </div>
                                <span className="px-3">{printData.mt_pelakdate}</span>
                            </li>
                        </div>
                        <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> نوع کاربری : </div>
                                <span className="px-3">{printData.tp_karbari}</span>
                            </li>
                            
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> سیستم : </div>
                                <span className="px-3">{printData.tp_system}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تیپ : </div>
                                <span className="px-3">{printData.tp_tip}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> رنگ : </div>
                                <span className="px-3">{printData.cl_name}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> مدل : </div>
                                <span className="px-3">{printData.mt_model}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold">  شماره بدنه  : </div>
                                <span className="px-3">
                                    {printData.mt_bodyno}
                                </span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> شماره انجین : </div>
                                <span className="px-3">
                                    {printData.mt_motorno}
                                </span>
                            </li>
                        </div>
                        <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تعداد محور : </div>
                                <span className="px-3">{printData.tp_mehvar}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تعداد چرخ : </div>
                                <span className="px-3">{printData.tp_charkh}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold">  ظرفیت : </div>
                                <span className="px-3">{printData.tp_zarfiyat}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تعداد سیلندر : </div>
                                <span className="px-3">{printData.tp_cylandr}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> نوع سوخت : </div>
                                <span className="px-3">{printData.tp_sookht}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> حجم سیلندر : </div>
                                <span className="px-3">{printData.tp_hajm}</span>
                            </li>
                        </div>
                    </div>                    
                    <div className='row g-2 p-5 my-5'> 
                        <Header title={'مشخصات خریدار'} /> 
                        <div className="col-7 col-md-8 p-3 list-group list-group-flush border">
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> نام نام خانوادگی : </div>
                                <span className="px-3">{printData['owner']['customer']['name']+' '+printData['owner']['customer']['family']}</span>
                            </li>
                            
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> نام پدر : </div>
                                <span className="px-3">{printData['owner']['customer']['father']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> محل ثبت تولد : </div>
                                <span className="px-3">{printData['owner']['customer']['birthplace']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> آدرس محل سکونت : </div>
                                <span className="px-3">{printData['owner']['customer']['address']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold">  شماره شناسنامه / ملی: </div>
                                <span className="px-3">{printData['owner']['customer']['nationalCode']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold">  کد پستی  : </div>
                                <span className="px-3">
                                    {printData['owner']['customer']['postalcode']}
                                </span>
                            </li>
                        </div>
                        <div className="col-5 col-md-4 p-3 list-group list-group-flush border">
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تاریخ ثبت تولد : </div>
                                <span className="px-3">{printData['owner']['customer']['birthregistrationdate']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold">  ثبت / شماره شناسنامه : </div>
                                <span className="px-3">{printData['owner']['customer']['idcard']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> ثبت / محل صدور : </div>
                                <span className="px-3">{printData['owner']['customer']['placeofissue']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> تلفن ثابت : </div>
                                <span className="px-3">{printData['owner']['customer']['phone']}</span>
                            </li>
                            <li className="list-group-item border-0 d-flex justify-content-start align-items-center">
                                <div className="fw-bold"> شماره موبایل : </div>
                                <span className="px-3">
                                    {printData['owner']['customer']['mobile']}
                                </span>
                            </li>
                        </div>
                    </div>
                    <div className="col-12 d-flex justify-content-end p-3 print-no mb-5">
                        <Button 
                            tab='6'
                            title=' برگشت به صفحه اسناد '
                            design=" px-0 py-1 btn btn-outline-dark fw-bold"
                            event={goToDocumentIndex}
                        />
                        <Button 
                            tab='14'
                            title=' چاپ سند موقت '
                            design="px-4 py-1 mx-3 btn btn-dark fw-bold"
                            event={documentPrintHandler}
                        />
                    </div>
                </>
                ) : null
        }
        </>
    )
}

export default DocumentPrint;